import { observer as LiteObserver } from "mobx-react-lite";
import { ComponentType } from "react";

import { TEt3Theme, withTheme } from "../et3-theme/";

type TFunc = <P extends object>(
  Component: React.ComponentType<P>
) => React.FunctionComponent<P>;
type TFuncs = TFunc[];

const compose = (...funcs: TFuncs) =>
  funcs.reduce(
    (a, b) =>
      (...args) =>
        a(b(...args)),

    (arg) => arg as React.FunctionComponent
  );

type WithThemeAndLiteObserver = <T extends {}>(
  component: ComponentType<T & { theme: TEt3Theme }>
) => ComponentType<T & { theme?: TEt3Theme }>;

export const withLiteObserverAndTheme = ((component) => {
  return compose(withTheme, LiteObserver)(component);
}) as WithThemeAndLiteObserver;
